<template>
  <el-card
    v-loading="isloading"
    class="warn-tab"
    shadow="never"
    :body-style="{ padding: 0 }"
  >
    <div slot="header" class="clearfix">
      <el-button
        style="float: right; padding: 3px 5px"
        type="text"
        class="danger-button"
        :disabled="!selections.length"
        @click="removeSelectOutliner"
      >
        清除 {{ selections.length ? `(${selections.length})` : '' }}
      </el-button>

      <el-button
        style="float: right; padding: 3px 5px"
        type="text"
        :loading="isloading"
        @click="listoutliners"
      >
        刷新
      </el-button>
    </div>
    <el-table
      :data="data"
      max-height="500"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="mmsi" label="MMSI" width="120" />
      <el-table-column prop="begin" label="查询范围">
        <template slot-scope="scope">
          {{ scope.row.begin }} - {{ scope.row.end }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80">
        <div slot-scope="scope">
          <el-button type="text" @click="lookup(scope.row)"> 查看 </el-button>
        </div>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev,pager,next"
      :total="count"
      :page-size="50"
      :current-page.sync="pagenum"
      class="warn-tab-pagination"
      @current-change="listoutliners"
    />
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import request from '@/mixins/request.js'

export default {
  mixins: [request],

  data() {
    return {
      data: [],
      isloading: false,
      selections: [],

      count: 0,

      pagenum: 1,
    }
  },

  mounted() {
    this.listoutliners()
    this.$on('activate', this.listoutliners)
  },

  methods: {
    async listoutliners() {
      this.isloading = true

      try {
        const resp = await this.$api.get('/schedules/voyageops/listoutliners', {
          params: {
            num: this.pagenum || 1,
          },
        })

        if (resp.data.status === 1) {
          this.data = resp.data.content.list
          this.$emit('count', (this.count = resp.data.content.total || 0))
          this.pagenum = resp.data.content.pageNum
        }
      } finally {
        this.isloading = false
      }
    },

    async removeoutliners(ids) {
      this.isloading = true
      try {
        const resp = await this.$api.post(
          '/schedules/voyageops/listoutliners',
          ids,
          {
            params: {
              num: 1,
            },
          }
        )

        if (resp.data.status === 1) {
          this.$message.success('删除成功!')
          await this.listoutliners()
        }
      } finally {
        this.isloading = false
      }
    },

    async removeSelectOutliner() {
      const ids = this.selections.map(it => it.id)
      if (ids.length) {
        try {
          await this.$confirm('确定删除?')
          await this.removeoutliners(ids)
        } catch (e) {}
      }
    },

    handleSelectionChange(selections) {
      this.selections = selections
    },

    lookup(row) {
      this.$emit('lookup', {
        mmsi: row.mmsi,
        begin: dayjs(row.begin, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs(row.end, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.warn-tab {
  .el-input__inner {
    width: 100%;
  }

  .danger-button {
    &:not(.is-disabled) {
      color: #f56c6c;
    }
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  border: none;

  .warn-tab-pagination {
    text-align: right;
    margin: 10px 5px;
  }
}
</style>
